import React, { createContext, useCallback, useMemo, useReducer } from 'react';
import PropTypes from 'prop-types';

import reducer, {
  SET_STEP,
  SET_SELECTED_COMMODITY,
  SET_SELECTED_PROPERTIES,
  SET_SHOW_TOAST,
  SET_TOAST_MESSAGE,
  SET_LOADING_FETCH
} from '../reducer';

export const initialState = {
  step: 1,
  selectedCommodity: { id: '', name: '' },
  cropZones: [],
  showToast: false,
  typeToast: 'success',
  messageToast: 'Yield data saved.',
  isLoading: false
};

export const YieldContext = createContext(initialState);

const YieldProvider = ({ children = null }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const goBack = useCallback(
    (specificStep = null) => {
      dispatch({
        type: SET_STEP,
        payload: specificStep || state.step - 1
      });
    },
    [state.step]
  );

  const goForward = useCallback(
    (specificStep = null) => {
      dispatch({
        type: SET_STEP,
        payload: specificStep || state.step + 1
      });
    },
    [state.step]
  );

  const updateSelectedCommodity = useCallback(selectedCommodity => {
    dispatch({
      type: SET_SELECTED_COMMODITY,
      payload: selectedCommodity
    });
  }, []);

  const updateCropZones = useCallback(cropZones => {
    dispatch({
      type: SET_SELECTED_PROPERTIES,
      payload: cropZones
    });
  }, []);

  const setIsLoading = useCallback(isLoading => {
    dispatch({
      type: SET_LOADING_FETCH,
      payload: isLoading
    });
  }, []);

  const setResponseToastMessage = useCallback(
    ({ type, message, isToastActive }) => {
      dispatch({
        type: SET_TOAST_MESSAGE,
        payload: {
          isToastActive,
          typeToast: type,
          messageToast: message
        }
      });
    },
    []
  );

  const setShowToast = useCallback(showToast => {
    dispatch({
      type: SET_SHOW_TOAST,
      payload: showToast
    });
  }, []);

  const contextValue = useMemo(
    () => ({
      state,
      dispatch,
      goBack,
      goForward,
      updateSelectedCommodity,
      updateCropZones,
      setShowToast,
      setResponseToastMessage,
      setIsLoading
    }),
    [
      state,
      goBack,
      goForward,
      updateSelectedCommodity,
      updateCropZones,
      setShowToast,
      setResponseToastMessage,
      setIsLoading
    ]
  );

  return (
    <YieldContext.Provider value={contextValue}>
      {children}
    </YieldContext.Provider>
  );
};

YieldProvider.propTypes = {
  children: PropTypes.node
};

export default YieldProvider;
